import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo';
import NatTokenRepo, {RegisterTokenSubResidentUserRequest} from '../token/repository/NatTokenRepo';
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo';
import {Location} from 'react-router-dom'
import {Nullable} from '../../../app/TypeHelpers';
import React, {ChangeEvent, Component, ReactElement} from 'react';
import {PlainLinkStyledBackButton, PrimaryStyledButton, StyledSecondaryButton} from '../../../styledComponents/Button';
import {BlockSpacer, currentMedia} from '../../../styledComponents/ResponsiveConvenience';
import {DisplayBlockDiv, DisplayItemDividerForPageTop,} from '../../../styledComponents/DisplayItem';
import {StyledPageTitle} from '../../../components/reservations/components/CommonStyle';
import {Box} from '@mui/material';
import {FlexContainer} from '../../../styledComponents/FlexComponents';
import {ItemHeading, WideWhiteArea} from '../applications/common/resident/NatResidentApplicationsCommon';
import NatResidentApplicationDetailFormItem from '../applications/common/resident/NatResidentApplicationDetailFormItem';
import PPRadioGroupForResident from '../../../components/shared/forms/resident/PPRadioGroupForResident';
import {SUB_USER_AUTHORITY_SETTING_ACCOUNT, SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT,} from '../../../CodeMaster';
import EventEmitterExResident from '../../../components/shared/pageBaseComponents/EventEmitterExResident';
import {PPTextFieldForResident} from '../../../components/shared/forms/resident/PPTextFieldForResident';
import {State} from '../../../components/facilities/AdminRegisterFacilityPage/FacilityForm';
import {Messages} from '../../../Messages';
import {NatPostTokenSubResidentUser} from '../token/repository/NatPostTokenSubResidentUser';
import {HKConstants} from '../../../HKConstants';
import AuthorityChecker from '../../../components/AuthorityChecker';
import styled from 'styled-components';
import {Colors, FontSize} from '../../../styledComponents/Constants';
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage';
import {
    HeadingAreaMessageComponentForResident
} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponentForResident';
import NatResidentMessageDialogComponent from '../common/resident/NatResidentMessageDialogComponent';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'

interface Props {
    condominiumCd: string,
    ridgeCd: string,
    roomNumber: string,
    residentUserRepo: NatResidentUserRepo,
    tokenRepo: NatTokenRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    location: Location,
    eventEmitter: EventEmitterExResident,
}

interface States {
    mailAddress: string
    mailAddressConfirm: string
    selectedAuthoritySettingBillingReceipt: string
    selectedAuthoritySettingAccount: string
    applyButtonDisabled: boolean
    dialogAddOpen: boolean
    errorTitleMessage: string
    isLoadCompleted: boolean
}


class NatResidentSubResidentUserAddPage extends Component<Props & ResidentWithErrorHandlingPagePropsSet, States> {
    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props);
        this.state = {
            mailAddress: '',
            mailAddressConfirm: '',
            selectedAuthoritySettingBillingReceipt: '',
            selectedAuthoritySettingAccount: '',
            dialogAddOpen: false,
            applyButtonDisabled: true,
            errorTitleMessage: '',
            isLoadCompleted: false,
        };
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleSubUserAuthoritySettingBillingReceipt = this.handleSubUserAuthoritySettingBillingReceipt.bind(this)
        this.handleSubUserAuthoritySettingAccount = this.handleSubUserAuthoritySettingAccount.bind(this)
        this.handleaddSubResidentUserButtonClick = this.handleaddSubResidentUserButtonClick.bind(this)
        this.handleAddCancelClick = this.handleAddCancelClick.bind(this)
        this.getFreeSettingItem = this.getFreeSettingItem.bind(this)
        this.handleAddOkClick = this.handleAddOkClick.bind(this)
        this.getAddDialogComponent = this.getAddDialogComponent.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading();
        try {
            this.setState({
                selectedAuthoritySettingBillingReceipt:
                SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT.BROWSE_IMPOSSIBLE.value,
                selectedAuthoritySettingAccount:
                SUB_USER_AUTHORITY_SETTING_ACCOUNT.BROWSE_IMPOSSIBLE.value

            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        } finally {
            this.props.eventEmitter.closeLoading();
            this.setState({isLoadCompleted: true})
        }
    }


    handleBackButtonClick(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/ridges/${this.props.ridgeCd}` +
            `/rooms/${this.props.roomNumber}/users`,)
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleSubUserAuthoritySettingBillingReceipt(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            selectedAuthoritySettingBillingReceipt: event.target.value,
        })
    }

    handleSubUserAuthoritySettingAccount(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            selectedAuthoritySettingAccount: event.target.value,
        })
    }

    handleaddSubResidentUserButtonClick(): void {
        this.setState({dialogAddOpen: true});
    }

    handleAddCancelClick(): void {
        this.setState({dialogAddOpen: false});
    }

    getFreeSettingItem(): string {
        const authorityList = [];
        switch (this.state.selectedAuthoritySettingBillingReceipt) {
            case SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT.BROWSE_POSSIBLE_ISSUE_POSSIBLE.value:
                authorityList.push('63-1-1');
                authorityList.push('64-18-1');
                break;
            case SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT.BROWSE_POSSIBLE_ISSUE_IMPOSSIBLE.value:
                authorityList.push('63-1-1');
                authorityList.push('64-18-0');
                break;
            case SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT.BROWSE_IMPOSSIBLE.value:
                authorityList.push('63-1-0');
                authorityList.push('64-18-0');
                break;
        }
        switch (this.state.selectedAuthoritySettingAccount) {
            case SUB_USER_AUTHORITY_SETTING_ACCOUNT.BROWSE_POSSIBLE.value:
                authorityList.push('65-1-1');
                break;
            case SUB_USER_AUTHORITY_SETTING_ACCOUNT.BROWSE_IMPOSSIBLE.value:
                authorityList.push('65-1-0');
                break;
        }
        authorityList.push('63-20-0');
        authorityList.push('64-20-0');
        authorityList.push('65-20-0');
        return authorityList.join(',');
    }

    async handleAddOkClick(): Promise<void> {
        this.setState({dialogAddOpen: false});
        const freeSettingItem = this.getFreeSettingItem();
        await this.props.eventEmitter.showLoading();
        try {
            // トークン登録(サブユーザ追加)
            const registerTokenRequest: RegisterTokenSubResidentUserRequest = {
                mailAddress: this.state.mailAddress,
                mailAddressConfirm: this.state.mailAddressConfirm,
                freeSettingItem: freeSettingItem
            };
            const ret: Nullable<NatPostTokenSubResidentUser> = await this.props.asyncCallFunction(
                this.props.tokenRepo.registerTokenSubResidentUser.bind(
                    this.props.tokenRepo, registerTokenRequest),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {
                    defaultErrorTitle: Messages.EOPCR0014.toString(),
                    defaultErrorTitlePriority: false,
                    replacementDetailErrorMessages: [{
                        targetMessageId: Messages.EOPCA0004,
                        replacementMessageId: Messages.EOPCR0015
                    }]
                },
            )
            if (ret) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/ridges/${this.props.ridgeCd}` +
                    `/rooms/${this.props.roomNumber}/users`,)
            }
        } catch (HttpError) {
        } finally {
            this.props.eventEmitter.closeLoading();
        }
    }

    getAddDialogComponent(): ReactElement | null {
        return (
            <NatResidentMessageDialogComponent
                open={this.state.dialogAddOpen}
                params={{
                    title: '確認',
                    titleIcon: <AddDialogTitleIconWrapper><ReportProblemOutlinedIcon titleAccess={'warning'}/>
                        </AddDialogTitleIconWrapper>,
                    errorLevel: Messages.IOPCR0001.errorLevel,
                    message: Messages.IOPCR0001.toString(''),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleAddCancelClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleAddOkClick,
                        },
                    ],
                }}
            />
        )
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            selectedAuthoritySettingBillingReceipt,
            selectedAuthoritySettingAccount,
            mailAddress,
            mailAddressConfirm
        } = this.state

        let applyButtonDisabled = false

        if (!selectedAuthoritySettingBillingReceipt || !selectedAuthoritySettingAccount || !mailAddress ||
            !mailAddressConfirm) {
            applyButtonDisabled = true
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    render(): Nullable<ReactElement> {
        const {
            selectedAuthoritySettingBillingReceipt,
            selectedAuthoritySettingAccount,
            mailAddress,
            mailAddressConfirm
        } = this.state
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackButtonClick}>
                    戻る
                </PlainLinkStyledBackButton>
                <BlockSpacer height={'14px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <StyledPageTitle>
                    サブユーザの追加
                </StyledPageTitle>
                <BlockSpacer height={'20px'}/>
                追加したいサブユーザのメールアドレスを入力し利用制限を設定のうえ「追加する」ボタンを押してください。
                <Box height={'20px'}/>
                <HeadingAreaMessageComponentForResident eventEmitter={this.props.eventEmitter}/>
                <WideWhiteArea>
                    <BlockSpacer height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>サブユーザ<BreakPcOnly/>メールアドレス</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        type: 'mailAddress',
                                        name: 'mailAddress',
                                        maxLength: 100,
                                        value: mailAddress,
                                        placeholder: '例：mail@example.com',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['mailAddress']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <BlockSpacer height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>サブユーザ<BreakPcOnly/>メールアドレス(確認用)</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        type: 'mailAddress',
                                        name: 'mailAddressConfirm',
                                        maxLength: 100,
                                        placeholder: '例：mail@example.com',
                                        value: mailAddressConfirm,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['mailAddressConfirm']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <BlockSpacer height={'20px'}/>
                </WideWhiteArea>
                <BlockSpacerPcOnly height={'10px'}/>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RESTRICTION_SETTING_BILLING_AMOUNT}>
                    <ItemHeading>
                        請求金額の閲覧・領収書発行
                    </ItemHeading>
                    <WideWhiteArea>
                        <BlockSpacer height={'20px'}/>
                        <TextStyled>管理費等お知らせからご請求金額を閲覧できる、お支払いが完了した内容の領収書を発行できる</TextStyled>
                        <BlockSpacer height={'10px'}/>
                        <PPRadioGroupForResident
                            data={SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT.values()}
                            selectValue={selectedAuthoritySettingBillingReceipt}
                            onChange={this.handleSubUserAuthoritySettingBillingReceipt}
                            eventKeys={['subUserAuthoritySettingBillingReceipt']}
                            eventEmitter={this.props.eventEmitter}
                        />
                        <BlockSpacer height={'20px'}/>
                    </WideWhiteArea>
                </AuthorityChecker>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RESTRICTION_SETTING_ACCOUNT_INFORMATION}>
                    <BlockSpacerPcOnly height={'15px'}/>
                    <ItemHeading>
                        口座情報の閲覧
                    </ItemHeading>
                    <WideWhiteArea>
                        <BlockSpacer height={'20px'}/>
                        <TextStyled>口座振替の情報から口座情報を閲覧できる</TextStyled>
                        <BlockSpacer height={'10px'}/>
                        <PPRadioGroupForResident
                            data={SUB_USER_AUTHORITY_SETTING_ACCOUNT.values()}
                            selectValue={selectedAuthoritySettingAccount}
                            onChange={this.handleSubUserAuthoritySettingAccount}
                            eventKeys={['subUserAuthoritySettingAccount']}
                            eventEmitter={this.props.eventEmitter}
                        />
                        <BlockSpacer height={'20px'}/>
                    </WideWhiteArea>
                </AuthorityChecker>
                <BlockSpacer height={'20px'}/>
                <DisplayBlockDiv>
                    <PrimaryStyledButton
                        onClick={this.handleaddSubResidentUserButtonClick}
                        disabled={this.state.applyButtonDisabled}
                    >
                        追加する
                    </PrimaryStyledButton>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <StyledSecondaryButton onClick={this.handleBackButtonClick}>戻る</StyledSecondaryButton>
                </DisplayBlockDiv>
                {this.getAddDialogComponent()}
            </>

        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentSubResidentUserAddPage)


const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`

const BlockSpacerPcOnly = styled(Box)`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`

const TextStyled = styled.div`
  color: ${Colors.AccentDark};
`
const AddDialogTitleIconWrapper = styled.div`
  line-height: 1;
  svg {
    font-size: ${FontSize.Big}!important;
    ${currentMedia.lessThan('sp')`
      font-size: ${FontSize.Accent}!important;
   `};
   }
`
;
